export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-simple-maps/node_modules/topojson-client/src/identity.js
// module id = wMCs
// module chunks = 0